export function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                has: function (key) {
                    return key in store;
                },
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Creates a cache of previously generated intl objects
 */
export function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
    };
}
